import comp from "./GenericCustomFieldModal";
export default comp;
